import { useEffect, useState } from 'react';
import bedroom1 from '../assets/bedroom1';
import bedroom2 from '../assets/bedroom2';
import bedroom3 from '../assets/bedroom3';
import livingroom1 from '../assets/livingroom1';
import livingroom2 from '../assets/livingroom2';
import livingroom3 from '../assets/livingroom3';

const base = process.env.PUBLIC_URL || '';
const IMAGES = [
  { src: bedroom1, alt: 'Modern living room set in warm oak and cream fabric' },
  { src: bedroom2, alt: 'Minimalist workspace with ergonomic chair and sleek desk' },
  { src: bedroom3, alt: 'Dining set for four with natural textures and soft lighting' },
  { src: livingroom1, alt: 'Modern living room set in warm oak and cream fabric' },
  { src: livingroom2, alt: 'Minimalist workspace with ergonomic chair and sleek desk' },
  { src: livingroom3, alt: 'Dining set for four with natural textures and soft lighting' }
];

const INTERVAL_MS = 4500;

export default function HeroCarousel() {
  const [index, setIndex] = useState(0);

  // useEffect(() => {
  //   const id = setInterval(() => {
  //     setIndex((i) => (i + 1) % IMAGES.length);
  //   }, INTERVAL_MS);
  //   return () => clearInterval(id);
  // }, []);

    useEffect(() => {
    const id = setTimeout(() => setIndex(i => (i + 1) % IMAGES.length), INTERVAL_MS);
    return () => clearTimeout(id);
  }, [index]);

  const SLOGAN = "Live Better, Rent Smarter"; // ← your caption here

  return (
    <section className="hero" aria-label="Featured furniture">
      <div className="hero-inner">
        <div className="carousel">
          <div className="hero-slogan hero-slogan--clear" role="heading" aria-level={1}>
            {SLOGAN}
          </div>
          {IMAGES.map((img, i) => (
            <img
              key={img.src}
              src={img.src}
              alt={img.alt}
              className={`slide ${i === index ? 'active' : ''}`}
              // aria-hidden={i === index ? 'false' : 'true'}
              decoding="async"
              loading={i === 0 ? 'eager' : 'lazy'}
            />
          ))}
        </div>  
      </div>
    </section>
  );
}
